import getMetaTagValue from '../../../../../lib/getMetaTagValue';

/**
 * Feature detects es6 browser via spread operator support, in order to set spoof flag.
 * @return {Boolean}
 */
function detectES6() {
    try {
        eval('const o={},x={...o};new Map()'); // eslint-disable-line no-eval
        return true;
    } catch (e) {
        return false;
    }
}

/**
 * @type {object}
 * @property {string} url
 * @property {string} referrer
 * @property {string} readyState
 * @property {string} facility
 * @property {string} creation
 * @property {string} locale
 * @property {string} pagename
 * @property {boolean} is_known_crawler
 * @property {boolean} suspected_spoof
 * @property {string?} pxid
 * @property {number?} age
 *
 */
let data;

/**
 * Create a clean stack.
 * @returns {Object}
 */
export function enrichment() {
    data = data || {
        url: window.location.href,
        referrer: document.referrer,
        facility: getMetaTagValue('fiverrmeta:facility') || 'web',
        creation: getMetaTagValue('fiverrmeta:creation'),
        locale: getMetaTagValue('fiverrmeta:locale'),
        pagename: getMetaTagValue('fiverrmeta:pagename'),
        is_known_crawler: getMetaTagValue('fiverrmeta:is_known_crawler') === 'true',
        suspected_spoof: !detectES6() && getMetaTagValue('es6_browser') === 'true'
    };

    data.readyState = document.readyState;
    try {
        data.pxid = window.sessionStorage.getItem('pxsid');
        data.age = Math.round(performance.now() / 1000);
    } catch { /* ignores */ }

    return data;
}
